<template>
  <div class="tree-container full">
    <Card class="full">
      <p slot="title">
        {{ $t(title) }}
      </p>
      <Row type="flex" justify="end" slot="extra">
        <!-- 公司编辑、添加 -->
        <template v-if="show && $store.state.user.user && $store.state.user.user.role === 'ROOT'">
          <img class="btn-img" @click.prevent="preAdd(true)" src="../../../../public/images/device/jiahao.png"
               alt="">
        </template>
      </Row>
      <Row style="margin: 5px 0;height: 5%;" :gutter="10">
        <Input v-model="depart_keyword" type="text" search :placeholder="$t('l.remark10')"
               @on-search="searchDepart"/>
      </Row>
      <Row style="height:calc(95% - 40px)">
        <div class="full" ref="treeBox">
          <Tree style="overflow-x: hidden;overflow-y: auto;height: 100%;" :data="departTree"
                :render="renderTree" :empty-text="$t('l.hint5')"></Tree>
          <Spin size="large" fix v-if="spin.depart"></Spin>
        </div>
      </Row>
    </Card>
    <template>
      <!-- 创建公司 -->
      <lg-modal :width="1240" :styles="{maxHeight:'650px',overflow:'auto',top: '50px'}" :title="modal.title"
                :confirm-text="$t('l.submit')" :show="modal.show" :loading="modal.loading"
                @on-submit="onSubmit('modal_depart')"
                @on-cancel="modal.loading=false;modal.show = false;modal.parent=null;">
        <Row :gutter="10">
          <Col :span='12'>
            <Form :model="modal.depart" :label-width="120" ref="modal_depart" :rules="modal.rules">
              <FormItem label="公司ID" v-if="modal.depart.id">
                <span style="font-weight: bold;">【{{ modal.depart.id }}】</span>
              </FormItem>
              <FormItem prop="name" :label="$t('l.name1')">
                <Input v-model="modal.depart.name" :placeholder="$t('l.name1')"></Input>
              </FormItem>
              <FormItem v-if="$store.state.user.isROOT" :label="$t('l.role')" prop="role_id">
                <Select @on-change="selectRole" v-model="modal.depart.role_id"
                        :placeholder="$t('l.role')" :transfer="true">
                  <Option v-if="role" v-for="role in rolePool" :key="role.id" :value="role.id"
                          :disabled="role.pid>0 && $store.state.user.isROOT">{{ role.name }}
                  </Option>
                </Select>
                <Poptip transfer :width="300" word-wrap :content="$t('l.explain2')">
                  <img class="cursor-pointor margin-left-10"
                       src="../../../../public/images/question-mark.svg" alt="">
                </Poptip>
              </FormItem>
              <!-- 如果是政监部门，得选推送平台 -->
              <template v-if="modal.depart.role_id == 7 && $store.state.user.isROOT">
                <FormItem :label="$t('l.select_push_city')">
                  <Select @on-change="selectPusher" v-model="modal.depart.pusher_label"
                          :placeholder="$t('l.select_push_city')" transfer>
                    <Option v-for="pusher in pusherPool" :key="pusher.id" :value="pusher.label">{{ pusher.name }}
                    </Option>
                  </Select>
                </FormItem>
              </template>
              <!-- 如果选择了公司 -->
              <FormItem :label="$t('l.region')">
                <Cascader v-model="modal.depart.j_region" :data="regionTree" change-on-select
                          @on-change="onRegionChange" :placeholder="$t('l.region')"></Cascader>
              </FormItem>
              <FormItem :label="$t('l.bind_community')" v-if="currentSelectedRole.type === 'WY_COMPANY'">
                <Select v-model="modal.depart.j_community_ids" :multiple="true" :filterable="true"
                        remote
                        :remote-method="regionQueryRemote"
                        :loading="modal.regionQueryLoading" :placeholder="$t('l.find_community')">
                  <Option v-for="community in modal.communitys" :key="community.name"
                          :value="community.id" :label="community.name"></Option>
                </Select>
              </FormItem>
              <FormItem :label="$t('l.contact')">
                <Poptip :width="500"  :title="$t('l.edit')" placement="right" transfer
                        ref="contact_editor"
                        @on-popper-hide="onContactEdit($refs.departContactEditor.contactThis)">
                  <Button type="primary"
                          :title="$t('l.click_edit')"
                          icon="md-options"
                          style="max-width: 300px; overflow: hidden">
                    {{
                      modal.depart.j_extra_info.contact &&
                      `${modal.depart.j_extra_info.contact.name} -
                                        ${modal.depart.j_extra_info.contact.mobile} -
                                        ${modal.depart.j_extra_info.contact.email}` || $t('l.edit')
                    }}
                  </Button>
                  <depart-contact-editor slot="content" ref="departContactEditor"
                                         :contact="modal.depart.j_extra_info.contact"
                                         @on-close="$refs.contact_editor.handleClose()">
                  </depart-contact-editor>
                </Poptip>
              </FormItem>
<!--              <FormItem v-if="modal.depart.role_type === 'ELEV_FACTORY'" :label="$t('l.hint6')"-->
<!--                        :title="getSigTip()">-->
<!--                <Tag @click.native="modal.depart.sms_signature_enabled = 0"-->
<!--                     v-if="modal.depart.sms_signature_enabled === 1">{{ modal.depart.sms_signature }}-->
<!--                  <Icon color="#996600" type="logo-vimeo"/>-->
<!--                </Tag>-->
<!--                <Tag @click.native="modal.depart.sms_signature_enabled = 0"-->
<!--                     v-else-if="modal.depart.sms_signature_enabled === -1">-->
<!--                  {{ modal.depart.sms_signature }}-->
<!--                  <Icon color="#ff0000" type="md-information-circle"/>-->
<!--                </Tag>-->
<!--                <Input v-else v-model="modal.depart.sms_signature" :placeholder="$t('l.hint7')"-->
<!--                       :class="[{enabled: modal.depart.sms_signature_enabled}, 'sms-signature']"-->
<!--                       @input="onSmsSingatureChanged"></Input>-->
<!--              </FormItem>-->
              <!-- 短信提醒开关 -->
              <FormItem :label-width="120" :label="$t('l.hint65')">
                <i-switch v-model="modal.depart.sms_switch" :true-value="1" :false-value="0"/>
              </FormItem>

              <!-- 短信提醒 -->
              <!-- 充值缴费负责人 -->
              <!--<FormItem :label="$t('l.hint52')" v-if="$store.state.user.isROOT" :label-width="100">-->
              <!--<Checkbox :true-value="1" :false-value="0" v-model="modal.depart.pay_on"-->
              <!--@on-change="$event && loadUsersWithIdForDepart()"></Checkbox>-->
              <!--<template v-if="modal.depart.pay_on">-->
              <!--<span> {{$t('l.account_balance')}}：<InputNumber v-model="modal.depart.pay_balance"-->
              <!--style="width: 100px;"-->
              <!--readonly></InputNumber></span>-->
              <!--<span> {{$t('l.principal')}}：-->
              <!--<Select v-model="modal.depart.pay_user" :placeholder="$t('l.principal')"-->
              <!--style="width: 100px">-->
              <!--<Option v-for="user in modal.userList" :key="user.id" :value="user.id"-->
              <!--:label="user.realname"></Option>-->
              <!--</Select>-->
              <!--&nbsp;-->
              <!--<Button icon="md-refresh" shape="circle" @click="loadUsersWithIdForDepart"-->
              <!--:title="$t('l.hint53')"></Button>-->
              <!--</span>-->
              <!--</template>-->
              <!--</FormItem>-->
              <!--<FormItem :label="$t('l.hint8')" v-if="$ifauth('fun_user_manual_bind')" :label-width="100">-->
              <!--<Checkbox :true-value="1" :disabled="modal.disabledBind" :false-value="0"-->
              <!--v-model="modal.depart.is_manual_bind"></Checkbox>-->
              <!--</FormItem>-->
              <!--<p class="explain">注：{{$t('l.explain3')}}</p>-->
              <!--<FormItem v-if="!modal.parent&&$ifauth('fun_user_special_res')" :label="$t('l.hint9')" :label-width="100">-->
              <!--<Checkbox v-model="modal.enableExtra"></Checkbox>-->
              <!--</FormItem>-->
              <!--<p v-if="!modal.parent&&$ifauth('fun_user_special_res')" class="explain">-->
              <!--注：{{$t('l.explain4')}}</p>-->
              <Row v-if="modal.depart.id" class="margin-top-10">
                <Upload :action="uploadAddress"
                        :data="{token:$store.state.user.user.token,cid:modal.depart.id}"
                        :on-success="uploadSuccess">
                  <Button type="primary" icon="ios-cloud-upload-outline">{{ $t('l.company_logo') }}
                  </Button>
                </Upload>
                <span class="explain">{{ $t("l.remark192") }}</span>
              </Row>
            </Form>
          </Col>
          <Col span="12">
            <div>
              <Form>
                <FormItem class="res-tree" :label="$t('l.hint10')">
                  <Collapse style="max-height: 500px;overflow-y: auto;" v-model="resTab" accordion
                            class="full-x">
                    <Panel name="sys">{{ $t('l.web_permission') }}
                      <div slot="content">
                        <auth-checker ref="auth_checker_sys" :res-tree="modal.authTree"
                                      @on-checked="onAuthChecked"></auth-checker>
                      </div>
                    </Panel>
                    <Panel name="app">
                      {{ $t('l.app_permission') }}
                      <div slot="content">
                        <auth-checker ref="auth_checker_app" :res-tree="modal.appTree"
                                      @on-checked="onAppAuthChecked"></auth-checker>
                      </div>
                    </Panel>
                    <Panel name="dtzh">
                      {{ $t('l.DTZJ_permission') }}
                      <div slot="content">
                        <auth-checker ref="auth_checker_dtzj" :res-tree="modal.dtzjTree"
                                      @on-checked="onDtzjAuthChecked"></auth-checker>
                      </div>
                    </Panel>
                  </Collapse>
                  <!-- 权限绑定注释 -->
                </FormItem>
              </Form>
            </div>
          </Col>
        </Row>
      </lg-modal>
      <!-- 绑定设备 -->
      <lg-modal :styles="{top:'10%'}" :show="deviceBindModel.show" :title="deviceBindModel.title" :width="'90%'"
                :confirm-text="$t('l.close')" :show-cancel="false" @on-submit="deviceBindModel.show=false;"
                @on-cancel="deviceBindModel.show=false;">
        <demo-bind-device v-if="deviceBindModel.show" ref="demoBindDevice"
                          :depart-id="contextMenu.currentObj.id"
                          :bind-ids="contextMenu.currentObj.j_demo_devices"></demo-bind-device>
      </lg-modal>
    </template>
  </div>
</template>

<script>
/**
 * 公司-部门管理
 * 只有公司直属员工可创建、更改部门及员工
 */
import LgModal from "../../my-components/lg-modal";
import util from '@/libs/util';
import ContextMenu from "../../my-components/context-menu";
import ResView from "../../my-components/res-view";
import DemoBindDevice from "./demo-bind-device";
import AuthChecker from "./auth-checker";
import DepartContactEditor from "./depart-contact-editor";

export default {
  name: "depart-tree-new",
  props: {
    show: {
      Boolean,
      default: true
    },
    title: {
      String,
      default: 'l.company_structure'
    }
  },
  // mixins: [modalAuthCheckMixin], // vue 混入对象
  components: {DepartContactEditor, AuthChecker, DemoBindDevice, ContextMenu, LgModal},
  data() {
    return {
      uploadAddress: util.baseURL + 'portal/upload_logo',
      resTab: 'sys',
      depart_keyword: '',
      contextMenu: {
        currentObj: null,
        show: false,
        position: {
          x: 0,
          y: 0
        },
        menus: [
          {
            icon: 'ios-add',
            text: 'l.add_son',
            callback: 'preAdd',
            show: true
          },
          {
            icon: 'ios-create-outline',
            text: 'l.property',
            callback: 'preEdit',
            show: true
          },
          {
            icon: 'ios-close',
            text: 'l.delete',
            callback: 'deleteDept',
            show: true
          }
        ]
      },
      departTree: [],
      regionTree: [],
      buttonProps: {
        type: 'default',
        size: 'small',
      },
      modal: {
        type: this.$t('l.company'),
        show: false,
        disabledBind: false,
        title: this.$t('l.create_company'),
        enableExtra: false,
        loading: false,
        regionQueryLoading: false,
        communitys: [],
        userList: [],
        parent: null,
        depart: {
          name: '',
          type: 0,
          pid: 0,
          role_id: 1,
          role_type: "",
          j_region: [],
          j_community_ids: [],
          j_auth_list: [],
          j_extra_auth: [],
          j_extra_info: {},
          sms_signature: '',
          sms_signature_enabled: 0,
          is_manual_bind: 0,
          pay_on: 0,
          sms_switch: 1,
          pay_balance: 0,
          pay_user: null,
          pusher_label: ''
        },
        rules: {
          name: [
            {required: true, message: this.$t('l.remark33'), trigger: 'blur'}
          ],
          role_id: [
            {required: true, message: this.$t('l.remark33'), trigger: 'blur', type: 'number'}
          ],
          // j_region:[{required: true, message: this.$t('l.remark33'), trigger: 'blur',type:'array'}]
        },
        authTree: [],
        appTree: [],
        dtzjTree: []
      },
      deviceBindModel: {
        show: false,
        title: this.$t('l.bind_test'),
        deviceIds: [],
      },
      current: {
        depart: {}
      },
      spin: {
        depart: false
      },
      checkedAuth: {
        sys: [],
        app: [],
        dtzj: []
      },
      pusherPool: []
    }
  },
  computed: {
    roleMap() {
      let map = {};
      this.$store.state.user.myRoles.forEach(role => {
        map[role.id] = role;
      })
      return map;
    },
    currentSelectedRole() {
      return this.roleMap[this.modal.depart.role_id] || {};
    },
    rolePool() {
      if (this.modal.parent) {
        if (this.modal.depart.type === 0) return [this.roleMap[this.modal.parent.role_id]];
        else {
          let roles = Object.keys(this.roleMap).filter(roleId => (this.roleMap[roleId].id === this.modal.parent.role_id || this.roleMap[roleId].pid === this.modal.parent.role_id || this.roleMap[roleId].type === 'CONSUMER')).map(id => this.roleMap[id]);
          return roles
        }
      } else {
        return this.$store.state.user.myRoles;
      }

    },
    currentHasChildCompany() {
      if (!this.modal.depart.children) return null;
      return this.modal.depart.children.find(d => d.type === 0)
    },
    currentUserDirectInCompany() {
      let user = this.$store.state.user.user;
      if (!user) return null;
      return user.role === 'ROOT' || user.departs.find(depart => depart.id === user.current_company)
    },
  },
  methods: {
    uploadSuccess(res) {
      if (!res.code) {
        this.$store.commit('setUserCompanyLogo', res.data.logo);
      }
    },
    onContactEdit(contact) {
      this.modal.depart.j_extra_info.contact = {
        name: contact.name,
        mobile: contact.mobile,
        email: contact.email.join(',')
      }
    },
    searchDepart(val) {
      if (val) {

        // 如果是管理员 则搜索全部公司，
        if (this.$store.state.app.departTree) {
          if (this.$store.state.user.isROOT) {
            this.departTree = this.$store.state.app.departTree.filter(elem => elem.name.includes(val))
          } else { // 如果不是管理员登录，则搜索根级公司下属所有
            this.departTree = [];
            this.$store.state.app.departTree.forEach(item => {
              let data = item.children.filter(elem => elem.name.includes(val));
              this.departTree.push(...data);
            })
          }
        }
      } else {
        //全部
        this.departTree = this.$store.state.app.departTree
      }
    },
    // 获取单位结构树
    loadTree() {
      this.spin.depart = true;
      util.ajax.get('/depart/list').then(res => {
        this.spin.depart = false;
        this.treeParseJSON(res.data);
        this.departTree = res.data;
        this.$store.commit('setDepartTree', res.data);
        //    加载完数据后直接查询用户及电梯
        this.$emit('on-select', res.data[0]);
        this.current.depart = res.data[0];
      })
    },
    treeParseJSON(list) {
      list.forEach(parent => {
        util.parseJSONResult(parent);
        if (!parent.j_demo_devices) parent.j_demo_devices = [];
        if (parent.children) {
          this.treeParseJSON(parent.children);
        }
      })
    },
    renderTree(h, {root, node, data}) {
      let roleName = '';
      if (this.roleMap[data.role_id]) roleName = '【' + this.roleMap[data.role_id].name + '】';
      return h('span', {
            style: {
              display: 'inline-block',
              width: '100%'
            }
          },
          [
            h('span',
                {
                  class: {
                    'tree-line': true,
                    'active': this.current.depart === data
                  },
                  on: {
                    'click': () => {
                      if (this.current.depart === data) {
                        this.current.depart = {};
                        this.$emit('on-select', 0)
                      } else {
                        this.current.depart = data;
                        this.$emit('on-select', data)
                      }
                    }
                  }
                },
                [
                  h('Icon', {
                    props: {
                      type: !data.pid ? 'ios-briefcase' : 'md-contacts'
                    },
                    style: {
                      marginRight: '8px'
                    }
                  }),
                  h('span', {
                    style: {
                      maxWidth: "190px",
                      display: "table-cell",
                      textOverflow: "ellipsis",
                      whiteSpace: "nowrap",
                      overflowX: "hidden"
                    }
                  }, [data.name])
                ]),
            this.currentUserDirectInCompany ? h('span',
                {
                  style: {
                    display: this.show ? 'inline-block' : 'none',
                    float: 'right',
                    marginRight: '32px'
                  }
                },
                [
                  h(ResView, {
                    props: {
                      keyName: 'fun_depart_manage'
                    }
                  }, [
                    h("div", {
                      style: {
                        display: 'flex'
                      }
                    }, [
                      h("Icon", {
                        props: {
                          type: 'md-add',
                          color: "#3399ff",
                          size: '20'
                        },
                        style: {
                          cursor: 'pointer',
                          display: !data.pid ? 'inline-block' : 'none'
                        },
                        on: {
                          "click": () => {
                            this.current.depart = data;
                            this.contextMenu.currentObj = data;
                            this.preAdd();
                          }
                        }
                      }),
                      h("Icon", {
                        props: {
                          type: 'ios-create',
                          color: "#3399ff",
                          size: '22'
                        },
                        style: {
                          cursor: 'pointer'
                        },
                        on: {
                          "click": () => {
                            if (data.pid) {
                              let p = root.find(el => el.node.id === data.pid);
                              if (p) this.modal.parent = p.node
                            }
                            this.current.depart = data;
                            this.contextMenu.currentObj = data;
                            this.preEdit();
                          }
                        }
                      }),
                      h("Icon", {
                        props: {
                          type: 'md-trash',
                          color: "#d81e06",
                          size: '20'
                        },
                        style: {
                          cursor: 'pointer'
                        },
                        on: {
                          "click": () => {
                            this.current.depart = data;
                            this.contextMenu.currentObj = data;
                            this.deleteDept();
                          }
                        }
                      }),
                    ])
                  ])
                ]) : ''
          ]);
    },
    preAdd(isTopLevel) {
      let parent = isTopLevel ? null : this.contextMenu.currentObj;
      this.modal.parent = parent;
      if (parent && parent.is_manual_bind) this.modal.disabledBind = true;
      else this.modal.disabledBind = false;
      // this.modal.enableExtra = false;
      this.modal.depart = {
        name: '',
        type: 0,
        pid: 0,
        role_id: 1,
        j_region: [],
        j_community_ids: [],
        j_auth_list: [],
        j_extra_auth: [],
        j_extra_info: {},
        sms_switch: 1,
        sms_signature: '',
        sms_signature_enabled: 0,
        is_manual_bind: parent ? parent.is_manual_bind : 0,
        pay_on: 0,
        pay_balance: 0,
        pusher_label: ''
      }
      if (parent) {
        this.modal.title = this.$t('l.create_department');
        this.modal.type = this.$t('l.department');
        this.modal.depart.pid = parent.id;
        this.modal.depart.company_id = parent.company_id;
        this.modal.depart.j_region = parent.j_region
        this.modal.depart.role_id = parent.role_id;
        this.modal.depart.role_type = parent.role_type;
      } else {
        this.modal.title = this.$t('l.create_company');
        this.modal.type = this.$t('l.company');
        this.modal.depart.type = 0;
      }
      this.$refs['modal_depart'].resetFields(); // 重置表单
      this.modal.show = true;
      if (isTopLevel) { // 新增公司，超级管理员
        this.selectRole(this.modal.depart.role_id);
      } else {  // 新增下级,默认获取父级公司全部权限
        this.getResTreeForExtraAuth(parent.j_auth_list);
      }

    },
    selectRole(role_id) {
      this.modal.depart.role_type = this.roleMap[role_id].type;
      //    管理员选择角色后自动分配已存在的角色权限
      let j_auth_list = this.roleMap[role_id].j_auth_list;
      this.getResTreeForExtraAuth(j_auth_list);
    },
    // 选择推送平台
    selectPusher() {

    },
    getResTreeForExtraAuth(list) {
      // if (!this.modal.parent) {   // 添根公司
      let language = localStorage.getItem("language");
      if(!language) language = "zh-CN";
      util.ajax.get('/res/getlist', {
        params: {
          language: language
        }
      }).then((res) => {// 服务器拉取 所有权限列表树
        let language = localStorage.getItem('language');
        if(!language) language = "zh-CN";
        this.modal.loading = false;
        if (language === 'en-US') {
          res.data.sys.forEach(elem => {
            elem.title = elem.res_name_en_us;
            this.setEnUsRes(elem);
          });
          res.data.app.forEach(elem => {
            elem.title = elem.res_name_en_us;
            this.setEnUsRes(elem);
          });
          res.data.dtzj.forEach(elem => {
            elem.title = elem.res_name_en_us;
            this.setEnUsRes(elem);
          });
        }else if(language === 'pt-PT'){
          res.data.sys.forEach(elem => {
            elem.title = elem.res_name_pt;
            this.setPtRes(elem);
          });
          res.data.app.forEach(elem => {
            elem.title = elem.res_name_pt;
            this.setPtRes(elem);
          });
          res.data.dtzj.forEach(elem => {
            elem.title = elem.res_name_pt;
            this.setPtRes(elem);
          });
        }

        let authTree = util.deepCopy(res.data.sys);
        let appTree = util.deepCopy(res.data.app);
        let dtzjTree = util.deepCopy(res.data.dtzj);

        // 获取所有选中的权限
        this.checkedAuth.sys = this.expandTree(authTree, list || this.modal.depart.j_auth_list.concat(this.modal.depart.j_extra_auth));
        this.checkedAuth.app = this.expandTree(appTree, list || this.modal.depart.j_auth_list);
        this.checkedAuth.dtzj = this.expandTree(dtzjTree, list || this.modal.depart.j_auth_list);
        this.modal.authTree = authTree;
        this.modal.appTree = appTree;
        this.modal.dtzjTree = dtzjTree;
      });
      // } else {  //添加下级,查询这个根公司下有多少权限
      //     this.modal.authTree = [];
      //     this.modal.appTree = [];
      // }
    },
    setEnUsRes(elem) {
      elem.title = elem.res_name_en_us;
      if (elem.children) {
        elem.children.forEach(item => {
          item.title = item.res_name_en_us;
          return this.setEnUsRes(item);
        })
      }
    },
    setPtRes(elem) {
      elem.title = elem.res_name_pt;
      if (elem.children) {
        elem.children.forEach(item => {
          item.title = item.res_name_pt;
          return this.setPtRes(item);
        })
      }
    },
    preEdit() {
      let depart = this.contextMenu.currentObj;
      console.log("depart:",depart);
      this.modal.type = this.$t('l.company');
      this.modal.title = this.$t('l.company_info');
      this.modal.depart = util.deepCopy(depart);
      this.modal.depart.j_extra_info = util.parseJSON(this.modal.depart.j_extra_info, {})
      this.modal.show = true;
      this.modal.loading = true;
      // if(this.$refs['modal_depart']){
      //   this.$refs['modal_depart'].resetFields(); // 重置表单
      // }
      this.getResTreeForExtraAuth(this.modal.depart.j_auth_list);
    },
    //删除公司
    deleteDept() {
      let data = this.contextMenu.currentObj
      util.ajax.get("/depart/checkExistUser?id=" + data.id).then(res => {
        if (!res.code) {
          if (!data.children) {
            this.$Modal.confirm({
              title: this.$t("l.warn"),
              content: data.type === 0 ? this.$t('l.remark168') : this.$t('l.remark169'),
              onOk: () => {
                util.ajax.get("/depart/delete?id=" + data.id).then(res => {
                  if (!res.code) {
                    this.loadTree();
                    this.$Message.success(this.$t('l.delete_success'))
                  }
                })
              },
            })
          } else {
            this.$Message.warning(data.type === 0 ? this.$t('l.remark170') : this.$t('l.remark171'));
          }
        }
      })
    },
    onSubmit(name) {
      let arr_sys = this.$refs.auth_checker_sys.$refs.res_tree.getCheckedAndIndeterminateNodes().map(node => (node.res_key));
      let arr_app = this.$refs.auth_checker_app.$refs.res_tree.getCheckedAndIndeterminateNodes().map(node => (node.res_key));
      let arr_dtzj = this.$refs.auth_checker_dtzj.$refs.res_tree.getCheckedAndIndeterminateNodes().map(node => (node.res_key));
      // this.modal.depart.j_auth_list = this.checkedAuth.sys.concat(this.checkedAuth.app);
      this.modal.depart.j_auth_list = arr_sys.concat(arr_app).concat(arr_dtzj);
      this.$refs[name].validate(valid => {
        if (valid) {
          console.log(this.modal.depart)
          if (this.modal.depart.role_id == 7 && !this.modal.depart.pusher_label) {
            this.$Message.error("政监部门必须选择一个地方推送平台！");
            return;
          }
          this.modal.loading = true;
          if (!this.modal.depart.id) {
            util.ajax.post("/depart/add", this.modal.depart).then(res => {
              this.modal.loading = false;
              if (!res.code) {
                this.loadTree();
                this.modal.show = false;
                this.$Message.success(this.$t('l.success'))
              }
            }).then(() => {
              this.modal.parent = null;
            })
          } else {
            let d = this.modal.depart;
            let depart = {
              id: d.id,
              name: d.name,
              type: d.type,
              pid: d.pid,
              sms_switch: d.sms_switch,
              company_id: d.company_id,
              role_id: d.role_id,
              j_region: d.j_region,
              j_community_ids: d.j_community_ids,
              j_extra_auth: d.j_extra_auth,
              j_extra_info: d.j_extra_info,
              j_auth_list: d.j_auth_list,
              sms_signature: d.sms_signature,
              sms_signature_enabled: d.sms_signature_enabled,
              is_manual_bind: d.is_manual_bind,
              pay_on: d.pay_on,
              pay_balance: d.pay_balance,
              pay_user: d.pay_user,
              role_type: d.role_type,
              pusher_label: d.pusher_label,
            }
            util.ajax.put("/depart/update", depart).then(res => {
              this.modal.loading = false;
              if (!res.code) {
                this.loadTree();
                this.modal.show = false;
                this.$Message.success(this.$t('l.remark166'));
              }
            }).then(() => {
              this.modal.parent = null;
            }).catch(er => {
              this.modal.loading = false;
            })
          }
        } else {
          this.$Message.error(this.$t('l.remark24'))
        }
      })
    },
    append(data) {
      const children = data.children || [];
      children.push({
        title: 'appended node',
        expand: true
      });
      this.$set(data, 'children', children);
    },
    remove(root, node, data) {
      const parentKey = root.find(el => el === node).parent;
      const parent = root.find(el => el.nodeKey === parentKey).node;
      const index = parent.children.indexOf(data);
      parent.children.splice(index, 1);
    },
    onRegionChange(value, selectedData) {

    },
    regionQueryRemote(name) {
      let level = "";
      switch (this.modal.depart.j_region.length) {
        case 1:
          level = 'province';
          break;
        case 2:
          level = 'city';
          break;
        case 3:
          level = 'area';
          break;
      }
      util.ajax.get("/community/getlistfordepart", {
        params: {
          name: name,
          regionId: this.modal.depart.j_region.slice(-1)[0],
          level: level
        }
      }).then(res => {
        this.modal.communitys = res.data || [];
      })
    },
    bindDeviceForDemo() {
      // let depart = util.deepCopy(this.contextMenu.currentObj);
      this.deviceBindModel.show = true;
      setTimeout(() => {
        this.$refs['demoBindDevice'].loadData();
      }, 100)
    },
    onSmsSingatureChanged(value) {
      if (value && value.trim() && this.contextMenu.currentObj.sms_signature && this.contextMenu.currentObj.sms_signature.trim()) {
        this.modal.depart.sms_signature_enabled = value === this.contextMenu.currentObj.sms_signature ? this.contextMenu.currentObj.sms_signature_enabled : 0;
      }
    },
    getSigTip() {
      let depart = this.contextMenu.currentObj;
      if (depart) {
        if (!depart.sms_signature) return this.$t('l.hint54') + '\n' + this.$t('l.hint55');
        if (depart.sms_signature_enabled === 1) return this.$t('l.hint56') + `\n${depart.sms_signature}`;
        if (depart.sms_signature_enabled === -1) return this.$t('l.hint57') + ` “${depart.sms_signature}”\n` + this.$t('l.hint58');
        return this.$t('l.hint59') + ` “${depart.sms_signature}”`;
      }
      return this.$t('l.hint60') + '\n' + this.$t('l.hint61')
    },
    onAuthChecked(auths,currentNode) {
      // let resKey = currentNode.res_key;
      // if(!auths.includes(resKey)){   // 取消操作
      //   // 如果额外权限列表 中存在  则删除
      //   if(this.modal.depart.j_extra_auth && this.modal.depart.j_extra_auth.includes(resKey)){
      //     let index = this.modal.depart.j_extra_auth.indexOf(resKey);
      //     this.modal.depart.j_extra_auth.splice(index,1);
      //   }
      // }
      this.checkedAuth.sys = auths;
    },
    onAppAuthChecked(auths) {
      this.checkedAuth.app = auths;
    },
    onDtzjAuthChecked(auths) {
      this.checkedAuth.dtzj = auths;
    },
    expandTree(tree, checkedAuthList) {
      let checkedList = [];
      tree.forEach(layer1 => {
        if (checkedAuthList.includes(layer1.res_key) && (!layer1.children || !layer1.children.length)) {
          layer1.checked = true;
          checkedList.push(layer1.res_key);
        } else layer1.children.forEach(layer2 => {
          if (checkedAuthList.includes(layer2.res_key) && (!layer2.children || !layer2.children.length)) {
            layer2.checked = true;
            layer1.expand = true;
            checkedList.push(layer2.res_key);
          } else {
            layer2.children.forEach(layer3 => {
              if (checkedAuthList.includes(layer3.res_key)) {
                layer3.checked = true;
                layer2.expand = true;
                checkedList.push(layer3.res_key);
              }
            })
          }
        })
      })
      return checkedList;
    },
    loadUsersWithIdForDepart() {
      if (!this.modal.depart.id) return;
      util.ajax.get('/user/listfordepart', {params: {id: this.modal.depart.id}}).then(res => {
        this.modal.userList = res.data;
      })
    },
    loadPushers() {
      util.ajax.get('/push/list').then(res => {
        this.pusherPool = res.data;
        const item = {
          id: 0,
          name: '*（* 代表可以查询全部地方平台设备）',
          label: '*'
        }
        this.pusherPool.unshift(item);
      });
    }
  },
  mounted() {
    util.ajax.get('/region/list').then(res => {
      this.regionTree = res.data;
    });
    this.loadPushers();
    this.loadTree();
  },
  created() {

  },
  activated() {


  }
}
</script>

<style scoped>
.tree-container {
  overflow: hidden;
  height: 100%;
}

a:visited {
  color: #39f;
}
</style>